import React, { Component } from 'react'
import autoBind from 'react-autobind'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { bindActionCreators } from 'redux'
import { Modal } from 'semantic-ui-react'

import { actions as messages } from '../store/actions/messages'

class Messages extends Component {
    constructor (props) {
        super(props)
        autoBind(this)
    }

    render () {
        return (
            <Modal
                onClose={(_e) => { this.props.clearMessage() }}
                open={!!this.props.message}
                dimmer='inverted'
                content={this.props.message && this.props.message.text}
                className={this.props.message && this.props.message.type}
                closeOnDocumentClick
                closeOnDimmerClick
                closeOnEscape
            />
        )
    }
}

const mapStateToProps = (state) => {
    return {
        language: state.settings.language,
        message: state.messages.message
    }
}

const mapDispatchToProps = (dispatch) => {
    const _messages = bindActionCreators(messages, dispatch)
    return {
        clearMessage: _messages.clearMessage
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Messages))



// WEBPACK FOOTER //
// ./src/components/messages.js